import { PermissionList } from '@/libs/defaultList';
export default [
    // *===============================================---*
    ///SERVICES ///
    {
        path: '/pipeline',
        name: 'pipeline',
        component: () => import('@/views/sales/pipeline/main.vue'),
        meta: {
            pageTitle: 'Pipeline',
            breadcrumb: [
                {
                    text: 'Pipeline',
                    active: true,
                },
            ],
            permission: PermissionList.Sales_View
        },
    },
]